import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForecastComponent } from './forecast.component';
import { MeteogramModule } from './meteogram/meteogram.module';
import { NotificationModule } from './notification/notification.module';
import { PredictionModule } from './prediction/prediction.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    ForecastComponent
  ],
  imports: [
    CommonModule,
    PredictionModule,
    MeteogramModule,
    NotificationModule,
    RouterModule
  ]
})
export class ForecastModule { }
